import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import { Breadcrumbs } from "@/components/ui/breadcrumb"
import { TherapyForm, type TherapyData } from "./TherapyForm"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & { therapy: TherapyData & { id: number; path: string } }

export default function TherapiesEdit() {
  const { props } = usePage<Props>()
  const { therapy } = props

  return (
    <AdminShell>
      <Head title={`Page Settings — ${therapy.label}`}>
        <meta name="description" content={`Settings for the ${therapy.label} page.`} />
        <meta property="og:title" content={`Page Settings — ${therapy.label}`} />
        <meta property="og:description" content={`Settings for the ${therapy.label} page.`} />
      </Head>

      <Breadcrumbs
        items={[
          { label: "Website Pages", href: "/admin/website" },
          { label: "Gisela Ramirez", href: "/admin/website?brand=gisela" },
          { label: therapy.label, href: `/admin/website/pages/${therapy.slug}` },
          { label: "Settings" },
        ]}
      />

      <PageHeader
        title={`${therapy.label} — settings`}
        description="The shell: address, visibility, labels and search metadata. The page's content is edited on its own content screen."
      />
      <div className="mt-8 max-w-2xl">
        <TherapyForm
          therapy={therapy}
          actionUrl={`/admin/website/therapies/${therapy.id}`}
          method="patch"
        />
      </div>
    </AdminShell>
  )
}
